import React from 'react';
import { OnBoardingSuccessLoader } from './OnBoardingLoader.style';
import { Spinner } from '@mindly/ui-components';
import { FormattedMessage } from 'react-intl';

const OnBoardingLoader = () => {
  return (
    <OnBoardingSuccessLoader>
      <Spinner />
      <div className={'loading-title'}>
        <FormattedMessage id={'general.loading'} defaultMessage={'Завантаження'} />
      </div>
      <div className={'loading-desc'}>
        <FormattedMessage id={'general.please.wait'} defaultMessage={'Будь ласка, зачекайте'} />
      </div>
    </OnBoardingSuccessLoader>
  );
};

export default OnBoardingLoader;
